import React from 'react';
import styled from 'styled-components';
import Box from 'ui/Box';
import NoneIcon from './none.svg?react';

const StyledSVGBox = styled(Box)`
  background-color: #f5f5f5;
  padding: 1.5rem;
`;

const NoneOptionImage = ({ ...props }) => {
  return (
    <StyledSVGBox {...props}>
      <Box
        as={NoneIcon}
        display="block"
        aria-hidden="true"
        color="currentColor"
        width="100%"
        height="100%"
      />
    </StyledSVGBox>
  );
};

export default NoneOptionImage;
